import axios from 'axios';

import { CUSTOMER_URL } from './apiUrls';
import { getSessionTokenHeader } from '../util/util';
import environment from 'environment';

export const updateUsedEasyConnections = async (params) => {
  const headers = await getSessionTokenHeader();
  const requestConfig = { headers };
  const requestParams = {
    usedEasyConnections: params.usedEasyConnections,
  };

  return await axios.post(
    `${CUSTOMER_URL}/${params.customerId}/update-used-easy-connections`,
    requestParams,
    requestConfig
  );
};

export const getEasyConnectionData = async (params) => {
  const requestParams = {
    businessId: params.businessId,
    conversationId: params.conversationId,
    subject: params.subject,
    message: params.message,
    customerId: params.customerId,
    shopNames: params.shopNames,
    customerEmail: params.customerEmail,
    brand: params.brand,
    expertId: params.expertId,
    customerName: params.customerName,
  };

  const sessionTokenHeader = await getSessionTokenHeader();
  const requestConfig = { headers: sessionTokenHeader };

  return await axios.post(environment.services.easyConnectionUrl, requestParams, requestConfig);
};
